import breakpoints from '../../theme/breakpoints'
import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .wrapper {
    display: flex;
    padding: 12px;
    flex-direction: column;
  }
  
  .hourly-container {
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
    background: ${theme.colors.brilliance};
    height: 300px;
    padding: 30px 15px;
    box-sizing: border-box;
  }

  .scroll-wrapper {
    overflow-x: scroll;
    width: 100%;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .scroll-wrapper::-webkit-scrollbar {
    display: none;
  }

  .hours {
    display: flex;
  }

  .temp-container {
    display: flex;
    flex-direction: column;
    min-width: 70px;
    align-items: center;
  }

  .value {
    margin-left: 4px;
    margin-bottom: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${redesignedTheme.colors.mineShaft};
  }

  .value:after {
    content: '°';
  }

  .vl {
    width: 6px;
    background-color: ${redesignedTheme.colors.lightBlue};
    border-radius: 3px;
    margin-bottom: 20px;
  }

  .time {
    color: ${redesignedTheme.colors.mineShaft};
    white-space: nowrap;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    border-top: 1px solid ${theme.colors.lightGray};
    padding: 16px 0 8px 0;
    text-align: center;
    width: 100%;
  }

  .temp-container .container-weather-icon {
    width: 32px;
    height: 19px;
    background-repeat: no-repeat;
    background-size: 32px 18px;
    margin-bottom: 12px;
  }

  .temp-container .precipitation {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #121212;
  }

  .temp-container .precipitation::after {
    content: '%';
  }

  .temp-container .precipitation::before {
    content: url('https://news12-weather-icons.s3.amazonaws.com/dew.png');
    margin-right: 3px;
  }
  
  @media only screen and (min-width: ${breakpoints.lg}px) {
    .wrapper {
      width: calc(100% - 364px);
    }
  }
`
